/* eslint-disable react-refresh/only-export-components */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { compose } from 'redux';

import { open as openCheckboxesDialog } from '@Containers/ResultsFilters/ResultsFiltersComponents/BarChartCheckboxesDialog/BarChartCheckboxesDialogActions';
import { open as openTreeViewDialog } from '@Containers/ResultsFilters/ResultsFiltersComponents/TreeViewDialog/TreeViewDialogActions';
import BarChartFilter from './BarChartFilter';
import {
  fetchFilterGroups as fetchFilterGroupsAction,
  toggleFilterGroup as toggleFilterGroupAction,
  fetchMoreFilterGroups as fetchMoreFilterGroupsAction,
  toggleFilterUserInput as toggleFilterUserInputAction,
  updateFilterUserInputValue as updateFilterUserInputValueAction,
} from './BarChartFilterActions';
import { open as openFilterByValueConfirmDialog } from './FilterByValueConfirmDialog/FilterByValueConfirmDialogActions';
import { open as openLoginPromptDialog } from './LoginPromptDialog/LoginPromptDialogActions';
import { groupsSelectorFactory } from './BarChartFilterSelectors';
import withBarChartFilterHandlers from './HOCs/withBarChartFilterHandlers';
import withBarChartFilterPropsMap from './HOCs/withBarChartFilterPropsMap';

export function BarChartFilterContainer(props) {
  const { filter, fetchFilterGroups, keyifyParamsForFiltersRequest } = props;
  const filterId = filter.get('id');
  const expanded = filter.get('expanded');

  useEffect(() => {
    if (expanded === true) {
      fetchFilterGroups(filter);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expanded, filterId, keyifyParamsForFiltersRequest]);
  return <BarChartFilter {...props} />;
}

BarChartFilterContainer.propTypes = {
  filter: PropTypes.instanceOf(Map),
  fetchFilterGroups: PropTypes.func,
  keyifyParamsForFiltersRequest: PropTypes.string,
};

function mapStateToProps() {
  const { groups, isGroupsFetching } = groupsSelectorFactory();

  return (state, ownProps) => ({
    groups: groups(state, ownProps),
    isGroupsFetching: isGroupsFetching(state, ownProps),
  });
}

const mapDispatchToProps = {
  toggleFilterGroup: toggleFilterGroupAction,
  fetchFilterGroups: fetchFilterGroupsAction,
  openTreeViewDialog,
  openCheckboxesDialog,
  fetchMoreFilterGroups: fetchMoreFilterGroupsAction,
  toggleFilterUserInput: toggleFilterUserInputAction,
  updateFilterUserInputValue: updateFilterUserInputValueAction,
  openFilterByValueConfirmDialog,
  openLoginPromptDialog,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withBarChartFilterPropsMap,
  withBarChartFilterHandlers
)(BarChartFilterContainer);
